// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__24B10","bigColWidth":"Table_bigColWidth__15jHP","biggerColWidth":"Table_biggerColWidth__iytsw","row":"Table_row__2DoiM","col":"Table_col__34DkC"};